import moment from 'moment'

import { Person, Pets, CalendarMonth, Alarm, WhatsApp } from '@mui/icons-material'
import { useSchedule } from '../../../../../../../../hooks/ScheduleContext'
import { secondsToHms } from '../../../../../../../../services/functions'
import {
  getConfirmationState,
  getConfirmationDescription,
} from '../../../../../../../../services/whatsappConfirmation'

import {
  Container,
  Content,
  Arrow,
  Header,
  Client,
  PetName,
  CustomerName,
  ScheduleData,
  ScheduleDate,
  ScheduleHour,
  ScheduleServices,
  ScheduleNotes,
  ConfirmationRow,
} from './styles'

export function Tooltip({ id }) {
  const { getBubbleById, getConfig } = useSchedule()

  const bubble = getBubbleById(id)
  const config = getConfig()
  const confirmationState = getConfirmationState(bubble.confirmation)

  return (
    <Container>
      <Content
        sideOffset={5}
        side="top"
        collisionPadding={{ top: 20, left: 80 }}
      >
        <Header>
          <Client>
            <PetName>
              <Pets /> <span>{bubble.petName.toLowerCase()}</span>
            </PetName>
            <CustomerName>
              <Person /> <span>{bubble.customerName}</span>
            </CustomerName>
          </Client>
          <ScheduleData>
            <ScheduleDate>
              <CalendarMonth /> {moment(config.date).format('DD/MM/YYYY')}
            </ScheduleDate>
            <ScheduleHour>
              <Alarm />
              {secondsToHms(bubble.startsAt).formated} -{' '}
              {secondsToHms(bubble.finishesAt).formated}
            </ScheduleHour>
          </ScheduleData>
        </Header>
        <ScheduleServices>
          {bubble.services.map((service) => (
            <p key={service}>{service.toLowerCase()}</p>
          ))}
        </ScheduleServices>
        {confirmationState && (
          <ConfirmationRow statusColor={confirmationState.color}>
            <WhatsApp />
            <span>{getConfirmationDescription(bubble.confirmation)}</span>
          </ConfirmationRow>
        )}
        {(bubble?.comment || bubble?.petComments) && (
          <ScheduleNotes>
            {bubble?.comment && (
              <p><strong>Obs. agendamento:</strong> {bubble?.comment}</p>
            )}
            {bubble?.petComments && (
              <p><strong>Obs. pet:</strong> {bubble?.petComments}</p>
            )}
          </ScheduleNotes>
        )}
        <Arrow />
      </Content>
    </Container>
  )
}
